(ns dashboard.views.user-preferences.events
  (:require [re-frame.core :as rf]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.notifications :as notifications]))

(rf/reg-event-fx
 ::save-user-preferences
 (fn [_ [_ preferences]]
   {:http-xhrio {:method :post
                 :uri "/api/user-preferences"
                 :params preferences
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::save-user-preferences-success]
                 :on-failure [::ui/set-error {:message "Failed to store preferences"}]}}))

(rf/reg-event-fx
 ::save-user-preferences-success
 (fn [{:keys [db]} [_ preferences]]
   {:db (assoc-in db [:user :preferences] preferences)
    :dispatch [::notifications/add {:message "Preferences saved"}]}))
